// extracted by mini-css-extract-plugin
module.exports = {"menu":"featured_menu__UZKV9"};